import type { ReactNode } from 'react';

import { cn } from '@shared/utils/cn';
import { Label } from '@shared/components/ui/label';

type Props = {
  id: string;
  label?: ReactNode;
  error?: string;
  helperText?: ReactNode;
  className?: string;
  children: ReactNode;
};

/** Label au-dessus + champ + message d'erreur / aide en dessous. */
export const FieldShell = ({ id, label, error, helperText, className, children }: Props) => (
  <div className={cn('flex flex-col gap-2', className)}>
    {label && <Label htmlFor={id}>{label}</Label>}
    {children}
    {(error || helperText) && (
      <p className={cn('text-xs', error ? 'text-destructive' : 'text-muted-foreground')}>{error ?? helperText}</p>
    )}
  </div>
);
